<template>
  <div class="inspiration-create">
    <!-- 顶部设置表单 -->
    <el-form :model="form" :rules="rules" ref="formRef" label-position="top" class="settings-form ghost-button-styles">
      <el-form-item label="创意灵感" prop="core_theme">
        <el-input
          v-model="form.core_theme"
          type="textarea"
          :rows="4"
          placeholder="画面描述：展示角色选择界面 (含黄帽、汉娜等)及高连击、特效拉满的战斗画面
情感/氛围：激发体验新游戏及重温经典的欲望
关键元素：街机恐龙, 角色选择界面, 高连击战斗画面, 轻松搬砖,自由交易, 一起重温经典吗
内容/叙事重点：推荐新游戏街机恐龙, 号召玩家体验"
        />
      </el-form-item>

      <el-form-item label="视频时长" required>
        <el-radio-group v-model="form.video_duration" size="small" class="duration-group">
          <el-radio-button ghost :label="15">15秒</el-radio-button>
          <el-radio-button ghost :label="30">30秒</el-radio-button>
          <el-radio-button ghost :label="45">45秒</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-button type="primary" class="action-button" icon="el-icon-magic-stick" @click="startAiCreate">AI即创作</el-button>
    </el-form>

    <!-- 脚本草稿列表 -->
    <div class="draft-section">
      <div class="section-header">
        <span class="title">AI生成的脚本草稿</span>
        <span class="meta">共 {{ scripts.length }} 个方案</span>
      </div>
      <el-card v-if="!scripts.length && !createLoading" class="empty-card" shadow="never">
        <div class="empty-wrap">
          <div class="empty-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="empty-title">还没有生成脚本</div>
          <div class="empty-desc">请在上方完成设置，开启你的第一次AI创作吧！</div>
          <el-button type="text" class="back-top" @click="scrollToTop">返回顶部</el-button>
        </div>
      </el-card>

      <!-- 生成后列表-->
      <ScriptDraftList v-else :loading="createLoading" :scripts="scripts"></ScriptDraftList>
      <!-- <ScriptDraftList :loading="createLoading" :scripts="scripts"></ScriptDraftList> -->
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { scriptOptimizeCreate } from '@/api/material.model.js'
import ScriptDraftList from './script-draft-list.vue'

const formRef = ref(null)
// 表单数据
const form = ref({
  core_theme: '',
  video_duration: 15
})

const rules = {
  core_theme: [
    { required: true, message: '请输入您的创意灵感', trigger: 'blur' },
    { min: 1, max: 200, message: '长度在1 到 200 个字符', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        !value.trim() ? callback(new Error('请输入您的创意灵感')) : callback()
      },
      trigger: 'blur'
    }
  ]
}

// 脚本草稿（占位）
const scripts = ref([])
const createLoading = ref(false)

function startAiCreate() {
  formRef.value.validate((valid) => {
    if (valid) {
      createLoading.value = true
      scriptOptimizeCreate({ function_type: 0, ai_params: { ...form.value } })
        .then((data) => {
          if (data) {
            console.log('datadatadatadata output: ', data)
            scripts.value = data
          }
        })
        .finally(() => {
          createLoading.value = false
        })
    }
  })
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style scoped lang="scss">
.inspiration-create {
  .settings-form {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 16px;

    .duration-group {
      margin-top: 4px;
    }

    .action-button {
      width: 100%;
      height: 44px;
      margin-top: 8px;
      font-weight: 600;
    }
  }

  .draft-section {
    margin-top: 16px;

    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 8px;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;

      .title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
      .meta {
        color: #909399;
        font-size: 13px;
      }
    }

    .empty-card {
      margin-top: 12px;
      text-align: center;
      .empty-wrap {
        padding: 24px 0 20px;
      }
      .empty-icon {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: #f5f7fa;
        margin: 0 auto 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 28px;
          color: #c0c4cc;
        }
      }
      .empty-title {
        font-size: 16px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 6px;
      }
      .empty-desc {
        color: #909399;
        font-size: 13px;
        margin-bottom: 6px;
      }
      .back-top {
        font-size: 13px;
      }
    }
  }
}
</style>
